import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { PRODUCT } from 'pricing-pages-api/EarlyRequesterNames';
import { getIsQAProxy } from '../utils/proxyUtils';
const PUBLIC_ENDPOINT = 'monetization/v3/product';
const ENDPOINT = 'monetization/v3/product/in-app';
export const getProducts = () => {
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${ENDPOINT}`;
  const earlyRequest = getEarlyRequesterResult(PRODUCT);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(url)) : null;
  return earlyRequestWithRetry || http.get(url);
};
export const getPublicProducts = () => {
  const countryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}${countryCode ? `?countryCode=${countryCode}` : ''}`;
  const earlyRequest = getEarlyRequesterResult(PRODUCT);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => noAuthHttp.get(url)) : null;
  return earlyRequestWithRetry || noAuthHttp.get(url);
};